import { render } from "./frequencyLimiting.vue?vue&type=template&id=89fddbe0&scoped=true"
import script from "./frequencyLimiting.vue?vue&type=script&lang=js"
export * from "./frequencyLimiting.vue?vue&type=script&lang=js"

import "./frequencyLimiting.vue?vue&type=style&index=0&id=89fddbe0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89fddbe0"

export default script